import { FormattedLocales } from "../src/shared/types/locales";

window.EasyAutomations ||= {};

window.EasyAutomations.initWebhookButton = async (moduleId: string, locales: FormattedLocales) => {
  const { initWebhookButton } = await import("../src/easy_legacy_js/automations_webhook");
  window.EasyAutomations.initWebhookButton = initWebhookButton;
  initWebhookButton(moduleId, locales);
};
